import React from "react"
import {breakpoints} from "@next/ux-fabric"
import {useMediaQuery} from "../../hooks/useMediaQuery"
import {configRelativePathURL} from "../../utils/configUrlPath"
import {Container, ItemHref, TitleContainer, IconContainer, TitleAndImageContainer} from "./component"
import SnailItemIcon from "../SnailItemIcon"
import connect from "./connect"
import NavIcon from "../NavIcon"
import urls from "../../config/urls"
import {LTR, VISITED_PAGES} from "../../config/constants"
import {Icons} from "../../models/secondary-nav"
import {setDepartment} from "../../utils/setDepartment"
import PromoIcon from "../PromoIcon"

type CatalogueItemProps = {
    target: string
    title: string
    englishTitle: string | null | undefined
    linkColour: string | null
    fontWeight: string
    catalogueListTitle: string | null
    department: string
    tab: string | null
    tabEnglish: string | null | undefined
    textAlignment: string
    promotionalIcon: string | null | undefined
    icons: Icons[] | undefined
    chevronIconAltText: string
    columnIndex: number | undefined
    siteUrl: string
    isIconEnabled: boolean
    realm: string
    rememberSelectedDepartment: boolean
    isFirstElement: boolean
    testingVariant: string | null
    englishDepartment: string | null | undefined
    englishCatalogueListTitle: string | null | undefined
    variant: string
    iconsVersionPath: string
    isDirectLink: boolean
}

const onClick = (target, department, siteUrl, rememberSelectedDepartment) => {
    localStorage.removeItem(VISITED_PAGES)
    const path = configRelativePathURL(target, siteUrl)
    setDepartment(path, department, rememberSelectedDepartment)
}

export const CatalogueItem = ({
    target,
    title,
    linkColour,
    fontWeight,
    catalogueListTitle,
    department,
    tab,
    tabEnglish,
    textAlignment,
    promotionalIcon,
    icons,
    chevronIconAltText,
    columnIndex,
    siteUrl,
    isIconEnabled,
    realm,
    rememberSelectedDepartment,
    isFirstElement,
    testingVariant,
    englishDepartment,
    englishCatalogueListTitle,
    englishTitle,
    variant,
    iconsVersionPath,
    isDirectLink,
}: CatalogueItemProps) => {
    const showIcon = isIconEnabled && isDirectLink
    const marketingStyles = {
        linkColour,
        fontWeight,
        isDirectLink,
    }
    const hideIconContainer = useMediaQuery(`(min-width: ${breakpoints.values.lg}px)`)
    const gaV2 = tabEnglish || englishCatalogueListTitle
    const gaV2Mp = tab || catalogueListTitle
    return (
        <Container
            {...marketingStyles}
            onClick={() => onClick(target, department, siteUrl, rememberSelectedDepartment)}
        >
            <ItemHref
                href={configRelativePathURL(target, siteUrl)}
                title={title}
                isDirectLink={isDirectLink}
                data-ga-v1-mp={department}
                data-ga-v2-mp={gaV2Mp}
                data-ga-v3-mp={title}
                data-ga-v5={testingVariant}
                data-testid="catalogueItem-href"
                data-ga-v1={englishDepartment || department}
                data-ga-v2={gaV2 || gaV2Mp}
                data-ga-v3={englishTitle || title}
            >
                <TitleAndImageContainer>
                    {showIcon && <SnailItemIcon icons={icons} realm={realm} />}
                    <TitleContainer isDirectLink={isDirectLink} isFirstElement={isFirstElement}>
                        {title}
                    </TitleContainer>
                    {promotionalIcon && (
                        <PromoIcon title={title} iconSrc={promotionalIcon} isFirstElement={isFirstElement} />
                    )}
                </TitleAndImageContainer>
            </ItemHref>
            {isDirectLink && !hideIconContainer && (
                <IconContainer>
                    <NavIcon
                        imageUrl={urls.burgerMenu.chevronUrl(realm, variant, iconsVersionPath)}
                        altText={chevronIconAltText}
                        width={1.5}
                        rotationDegrees={textAlignment === LTR ? -90 : 90}
                    />
                </IconContainer>
            )}
        </Container>
    )
}

export default connect(CatalogueItem)
